import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      style={{ backgroundColor: `color-mix(in oklch, var(--accent) 30%, transparent)` }}
      className={cn("animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }